import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const DigitalStrategy = () => {
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 })

    return (
        <div className="w-full mx-auto p-6 lg:px-12 lg:py-16 text-zinc-800 dark:text-zinc-200 text-sm" ref={ref}>
            <div className="grid lg:grid-cols-2 gap-12 items-center justify-between">

                <motion.div 
                    className="lg:w-11/12 space-y-4 lg:space-y-6"
                    initial={{ opacity: 0, x: -50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="flex flex-row text-zinc-800 dark:text-zinc-200 font-light items-center justify-between">
                        <div className="flex justify-start space-x-3 items-center">
                            <span className="text-purple-600 dark:text-purple-400 font-mono text-xl font-bold">04</span>
                            <span className="text-3xl lg:text-4xl font-bold text-zinc-900 dark:text-white">Strategic Business Alignment</span>
                        </div>
                    </div>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        Successful AI programs require more than engineering proficiency. They require boardroom alignment and business-first strategy. We align your AI development roadmap directly with long-term company KPIs, operational savings, and revenue generation.
                    </p>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        Backed by top-tier business strategy from Cornell's Executive MBA program and years of leading engineering management at major financial institutions, we navigate strict enterprise compliance, data security constraints, and scale.
                    </p>
                </motion.div>

                <motion.div 
                    className="mx-auto lg:w-11/12 w-full"
                    initial={{ opacity: 0, x: 50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="p-8 rounded-2xl border border-slate-200 dark:border-purple-500/20 bg-white dark:bg-[#202222] shadow-[0_4px_20px_rgba(0,0,0,0.03)] dark:shadow-[0_0_35px_rgba(168,85,247,0.08)] hover-glow transition-all duration-300">
                        <h4 className="text-sm font-semibold mb-6 text-zinc-900 dark:text-white flex items-center space-x-2">
                            <span>Strategic Pillars</span>
                        </h4>
                        <div className="space-y-4 font-sans text-xs">
                            <div className="flex items-start space-x-3">
                                <span className="bg-purple-500/20 text-purple-600 dark:text-purple-400 p-1 rounded font-mono font-bold">EMBA</span>
                                <div>
                                    <div className="font-semibold text-zinc-900 dark:text-white">Executive Acumen</div>
                                    <div className="text-[11px] text-zinc-500 dark:text-zinc-400 mt-0.5">Cornell University Executive MBA expertise focused on operational scale, financial audits, and organizational growth.</div>
                                </div>
                            </div>
                            <div className="flex items-start space-x-3">
                                <span className="bg-purple-500/20 text-purple-600 dark:text-purple-400 p-1 rounded font-mono font-bold">FIN</span>
                                <div>
                                    <div className="font-semibold text-zinc-900 dark:text-white">Enterprise Compliance</div>
                                    <div className="text-[11px] text-zinc-500 dark:text-zinc-400 mt-0.5">Years of engineering management inside Tier 1 financial institutions, leading security and regulatory compliance.</div>
                                </div>
                            </div>
                            <div className="flex items-start space-x-3">
                                <span className="bg-purple-500/20 text-purple-600 dark:text-purple-400 p-1 rounded font-mono font-bold">GDE</span>
                                <div>
                                    <div className="font-semibold text-zinc-900 dark:text-white">Global Tech Leadership</div>
                                    <div className="text-[11px] text-zinc-500 dark:text-zinc-400 mt-0.5">Google Developer Expert for Android recognition, speaking internationally and leading cross-platform standards.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>

            </div>
        </div>
    )
}

export default DigitalStrategy